/* eslint-disable import/prefer-default-export */
import { createSelector } from '@reduxjs/toolkit';
import { RootState } from '../Store';

const self = (state: RootState) => state.order;

export const getOrder = createSelector(self, (state) => state.order);
export const getOrderData = createSelector(getOrder, (state) => state.data);
export const getPaidAmount = createSelector(self, (state) => state.paidAmount);
export const getOrderCancel = createSelector(self, (state) => state.cancel);
